import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

const PaymentResult = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const success = searchParams.get("success");
  const isSuccess = success === "1";

  useEffect(() => {
    const timer = setTimeout(() => {
      window.close();
      navigate("/integration/woocom");
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white shadow-lg rounded-2xl p-10 text-center w-[90%] max-w-md">

        {/* <div className="flex items-center justify-center gap-4 mb-6">
          <img
            src="/assets/images/logo1.png"
            alt="App Logo"
            className="h-10 object-contain"
          />
          <span className="text-gray-400 text-lg">↔</span>
          <img
            src="/assets/images/Woo.svg"
            alt="WooCommerce"
            className="h-10 object-contain"
          />
        </div> */}

        {isSuccess ? (
          <>
            <div className="text-green-500 text-5xl mb-4">🔗✅</div>

            <h1 className="text-2xl font-bold text-gray-800 mb-2">
              WooCommerce Connected
            </h1>

            <p className="text-gray-500 mb-4">
              Your WooCommerce store has been connected successfully.
            </p>

            <p className="text-sm text-gray-400">
              Redirecting automatically...
            </p>
          </>
        ) : (
          <>
            <div className="text-red-500 text-5xl mb-4">🔗❌</div>

            <h1 className="text-2xl font-bold text-gray-800 mb-2">
              WooCommerce Connection Failed
            </h1>

            <p className="text-gray-500 mb-6">
              We couldn’t connect your store. Please try again.
            </p>

            {/* <button
              onClick={() => navigate("/integration/woocom")}
              className="bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-lg transition"
            >
              Try Again
            </button> */}
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentResult;